import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import useWindowDimensions from '../../../../utils/useWindowDimensions';

const LearningProductivity = ({labels, skillStreamCounts }) => {
    let {width , height} = useWindowDimensions();
    const staticSeriesName = 'Learning';
    
    const [chartOptions, setChartOptions] = useState({});
    const [chartSeries, setChartSeries] = useState([]);

    useEffect(() => {

        setChartOptions({
            chart: {
                type: 'bar',
                width: '100%',
                toolbar: {
                    show: false
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "55%",
                    endingShape: "rounded",
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 2,
                colors: ["transparent"],
            },
            xaxis: {
                categories: labels,
                tickAmount: 15
            },
            fill: {
                opacity: 1,
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
            colors: ["#CA353B"],
        });

        setChartSeries([{
            name: staticSeriesName,
            data: skillStreamCounts,
        }]);

    }, [labels, skillStreamCounts]);

    return (
        <div id="chart">
            <ReactApexChart 
            options={chartOptions} 
            series={chartSeries} 
            type="bar"  
            height={width > 1400 && width < 1650 ? 270 : width > 1650 ? 320 : 235}
             />
        </div>
    );
}

export default LearningProductivity;
